import React, { useContext, useEffect } from 'react';
import InputAutosize from 'react-input-autosize';
import { NumericFormat } from 'react-number-format';

import { PortfolioManagementContext } from '../../../../../../../providers/portfolio-management';
import { riskTypes } from '../../../../../../../providers/risk-management/risk-management-provider';
import { IAccountOption } from '../../../../../../../providers/venue-provider';
import { useFreezeSpotValues } from '../../../../../hooks/use-freeze-spot-values';

interface SpotOverrideInputProps {
  cellContent: string;
  riskType: riskTypes;
  accountOption: IAccountOption;
}

export const SpotOverrideInput: React.FC<SpotOverrideInputProps> = ({
  cellContent,
  riskType,
  accountOption,
}) => {
  const { spotOverrideValue, setSpotOverrideValue } = useContext(PortfolioManagementContext);
  const { updateFreezeSpotMapAndCallGetData } = useFreezeSpotValues();

  const handleBlur = (): void => {
    if (spotOverrideValue === '') {
      setSpotOverrideValue(cellContent);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (spotOverrideValue === '') return;

    if (e.key === 'Enter') {
      if (e.shiftKey) {
        updateFreezeSpotMapAndCallGetData({ accountOption, riskType });
      }
    }
  };

  useEffect(() => {
    if (cellContent !== spotOverrideValue) {
      setSpotOverrideValue(cellContent);
    }
  }, [cellContent]);

  return (
    <NumericFormat
      customInput={InputAutosize}
      decimalScale={2}
      value={spotOverrideValue}
      onChange={(e) => setSpotOverrideValue(e.target.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      thousandSeparator=","
      decimalSeparator="."
      fixedDecimalScale
      allowNegative
    />
  );
};
